import { getAnalyticsData } from './googleAnalyticsHelper'
import {
  getSearchParamsAsObject,
  getUtmParamsAsObject
} from './searchParamsHelper'
import {
  getFromSessionStorage,
  getUtmExamsFromSessionStorage
} from './storageHelpers'

export const buildUtmsMotion = () => {
  const utmsFromStorage = getFromSessionStorage('utms')

  if (!utmsFromStorage) return

  const { clientId, sessionId, sessionNumber } = getAnalyticsData()

  return {
    clientId,
    sessionId,
    sessionNumber,
    uid: utmsFromStorage?.uid,
    referrer: document.referrer || undefined,
    source: utmsFromStorage?.utm_source,
    campaign: utmsFromStorage?.utm_campaign,
    medium: utmsFromStorage?.utm_medium,
    term: utmsFromStorage?.utm_term
  }
}

export const getUtmExams = () => {
  const hasUtmExams = getUtmExamsFromSessionStorage()

  if (!hasUtmExams) {
    return null
  }

  return {
    utm_source: hasUtmExams.utmSource,
    utm_medium: hasUtmExams.utmMedium,
    utm_campaign: hasUtmExams.utmCampaign,
    utm_term: hasUtmExams.utmTerm,
    utm_content: hasUtmExams.utmContent
  }
}

export const extractUtmsFromSearchParams = (searchParams: URLSearchParams) => {
  const params = getSearchParamsAsObject(searchParams)
  const utmsFromParams = getUtmParamsAsObject(params)

  if (Object.keys(utmsFromParams).length > 0) {
    return utmsFromParams
  }

  const utmsFromSession = getFromSessionStorage('utms')

  if (utmsFromSession) {
    return utmsFromSession
  }

  return getUtmExams()
}
